export default __webpack_public_path__ + "i18n/translation-pt.7cec3060.json";